import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import Divider from '@material-ui/core/Divider'
import Popover from '@material-ui/core/Popover'
import { makeStyles, Theme } from '@material-ui/core/styles'
import React from 'react'
const useStyles = makeStyles((theme: Theme) => ({
    filterBox: {
        width: 'auto',
        height: 'auto',
        border: '1px solid #C9C9C9',
        boxShadow: '4px 4px 20px rgba(0, 0, 0, 0.3)',
        borderRadius: 5,
    },
    filterBoxHeaderTextContainer: {
        height: 56,
        padding: 14,
    },
    filterBoxAutocompleteContainer: {
        padding: 10,
        flex: 1,
    },
    filterBoxHeaderText: {
        fontWeight: 500,
        fontSize: pxToRem(20),
        lineHeight: pxToRem(25),
        color: '#047A7D',
    },
    divider: {
        backgroundColor: '#000000',
        height: 2,
    },
}))

export interface ListingHeaderPopoverProps {
    sectionLabel: string
    isPopoverOpen: boolean
    popoverContents?: JSX.Element
    popoverAnchorEl?: HTMLButtonElement | null
    handlePopoverClose: VoidFunction
}

const ListingHeaderPopover: React.FC<ListingHeaderPopoverProps> = ({
    sectionLabel,
    isPopoverOpen,
    popoverContents,
    popoverAnchorEl,
    handlePopoverClose,
}) => {
    const classes = useStyles()
    return (
        <Popover
            anchorEl={popoverAnchorEl}
            open={isPopoverOpen}
            onClose={handlePopoverClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: -7,
                horizontal: 'center',
            }}
            marginThreshold={7}
            data-testid={'headerPopover'}
        >
            <GridContainer direction="column" className={classes.filterBox}>
                <GridItem className={classes.filterBoxHeaderTextContainer}>
                    <span
                        className={classes.filterBoxHeaderText}
                        data-testid="headerPopoverSectionlabel"
                    >
                        {sectionLabel}
                    </span>
                </GridItem>
                <GridItem>
                    <Divider classes={{ root: classes.divider }} />
                </GridItem>
                <GridItem
                    className={classes.filterBoxAutocompleteContainer}
                    data-testid="headerPopoverContents"
                >
                    {popoverContents}
                </GridItem>
            </GridContainer>
        </Popover>
    )
}

export default ListingHeaderPopover
